<template>
  <div class="user-list">
    <h1>{{ $t("r.organization_list") }}</h1>
    <div class="operation-container">
      <el-button type="primary" @click="createOrganization()">
        {{ $t("organization.create") }}
      </el-button>
    </div>
    <div class="query-container"></div>
    <div class="tbl-user-list">
      <el-table
        v-loading="tblOrganizationListLoading"
        height="90%"
        :data="orgList"
      >
        <el-table-column width="400" prop="id" :label="$t('ULV.id')" />
        <el-table-column
          prop="name"
          show-overflow-tooltip
          :label="$t('ULV.name')"
        />
        <el-table-column fixed="right" width="200" :label="$t('ULV.operation')">
          <template #default="scope">
            <el-button
              type="primary"
              size="small"
              @click="enterOrganizationInfo(scope.row)"
            >
              {{ $t("ULV.btnEnterUserInfo") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer
      v-model="createdOrganizationDrawerVisible"
      :title="$t('organization.create')"
    >
      <el-form
        ref="createdUserFormRef"
        :model="createdOrganizationForm"
        label-width="auto"
        :rules="createdUserRule"
      >
        <el-form-item :label="$t('organization.name')" prop="name">
          <el-input v-model="createdOrganizationForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="btnSubmitLoading"
            @click="submitForm(createdUserFormRef)"
          >
            创建
          </el-button>
          <el-button type="danger" @click="resetForm(createdUserFormRef)">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script lang="ts" setup>
import {
  createOrganizationApi,
  fetchOrganizationListApi,
} from "@/api/organization/organizationApi";
import router from "@/router";
import {
  FetchOrganizationListParams,
  Organization,
} from "@/types/organization";
import { ElMessage, FormInstance, FormRules } from "element-plus";
import { onMounted, reactive, ref } from "vue";

// 获取用户列表
const tblOrganizationListLoading = ref<boolean>(false);
const orgList = ref<Organization[]>([]);
const params = reactive<FetchOrganizationListParams>({
  page: 1,
  size: 20,
  name: "",
});
const fetchOrganizationList = async () => {
  tblOrganizationListLoading.value = true;
  const response = await fetchOrganizationListApi(params);
  tblOrganizationListLoading.value = false;
  if (response) {
    orgList.value = response;
  }
};

// 用户列表点击进入用户信息
const enterOrganizationInfo = (org: Organization) => {
  console.log(org);
  router.push({ name: "organizationInfo", query: { orgId: org.id } });
};

// 创建用户
const createdUserFormRef = ref<FormInstance>();
const createdOrganizationDrawerVisible = ref<boolean>(false);
const createdUserRule = reactive<FormRules>({
  name: [{ required: true, message: "请输入集团名称", trigger: "blur" }],
});
const createdOrganizationForm = reactive({
  name: "",
});
const createOrganization = () => {
  createdOrganizationDrawerVisible.value = true;
};
const btnSubmitLoading = ref<boolean>(false);
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      const organization = {
        name: createdOrganizationForm.name,
      } as Organization;
      btnSubmitLoading.value = true;
      const response = await createOrganizationApi(organization);
      console.log(response);
      btnSubmitLoading.value = false;
      if (response && response == true) {
        ElMessage.success("集团创建成功！");
        createdOrganizationDrawerVisible.value = false;
        fetchOrganizationList();
      } else {
        ElMessage.error("集团创建失败！");
      }
    } else {
      ElMessage.error("信息填写错误！");
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  createdOrganizationDrawerVisible.value = false;
};

onMounted(() => {
  fetchOrganizationList();
});
</script>
<style lang="less" scoped>
.user-list {
  min-height: 500px;
  padding: 7px;
}
.operation-container {
  margin-bottom: 20px;
}
.pagination {
  float: right;
  margin-top: 20px;
}
.tbl-user-list {
  width: 100%;
  box-shadow: 0 0 10px 1px rgb(228, 228, 228);
  height: calc(100% - 110px);
  min-height: 400px;
  padding: 5px 20px;
}
</style>
